import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { AppErrorScreen } from '@/app/errors/AppErrorScreen';
import { reportClientError } from '@/shared/lib/error/reportClientError';
/**
 * 捕获路由树之外的渲染异常（全局弹窗等）并提供可恢复入口。
 * 路由内部的渲染与 loader 异常由数据路由的 errorElement 兜底，
 * 两者复用同一个降级界面。
 */
export class AppErrorBoundary extends Component {
    /** 初始化错误边界为空闲状态。 */
    state = { error: null };
    /** React 捕获后续渲染错误时生成降级状态。 */
    static getDerivedStateFromError(error) {
        return { error };
    }
    /** 上报不含业务敏感数据的错误摘要（错误对象与组件栈），供监控与排查使用。 */
    componentDidCatch(error, errorInfo) {
        reportClientError('app', error, errorInfo.componentStack);
    }
    /** 根据是否捕获错误选择正常子树或降级界面。 */
    render() {
        if (this.state.error) {
            return _jsx(AppErrorScreen, {});
        }
        return this.props.children;
    }
}
